/* TUDOR Mobile Menu
========================================= */
var header = document.getElementById('MiniHeader');
var button = document.getElementById('MiniHeaderMobileButton');

if (button && header) {
  button.addEventListener('click', function() {
    header.classList.toggle('mini-header--active');
  });
}